"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBase64Url = void 0;
const createToBase64_1 = require("./createToBase64");
exports.toBase64Url = (0, createToBase64_1.createToBase64)('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_', '');
